export const COMPARISON_MODE_EMPTY_STATE =
  'Select the periods you would like to compare, then press Apply View.'

export const COMPARISON_MODE_CARD_MESSAGE =
  'Additional summary metrics are visible only in Summary Mode.'
